<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">OpenOffice Export</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <p class="mb-3 text-muted">
            Wähle eine OpenOffice-Vorlage (.odt/.ott) aus und starte den Export.
          </p>

          <div class="mb-3">
            <label class="form-label" for="templateSelect">Vorlage</label>
            <select
              id="templateSelect"
              class="form-select"
              v-model="selectedTemplateId"
            >
            <option disabled value="">Bitte Vorlage auswählen</option>
              <option
                v-for="template in templates"
                :key="template.id"
                :value="template.id"
              >
                {{ template.originalFileName }} ({{ template.fileType }})
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="outputFileName">Dateiname (optional)</label>
            <input
              id="outputFileName"
              class="form-control"
              type="text"
              v-model.trim="outputFileName"
              placeholder="z. B. rechnung-export.odt"
            />
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <small v-if="loadingTemplates" class="text-muted">Vorlagen werden geladen...</small>
            <small v-else-if="templates.length === 0" class="text-warning">
              Keine OpenOffice-Vorlagen gefunden.
            </small>
            <button type="button" class="btn btn-link p-0" @click="goToTemplateAdmin">
              Vorlagen verwalten
            </button>
          </div>

          <div class="form-check mb-2">
            <input id="runAiReview" class="form-check-input" type="checkbox" v-model="runAiReview" />
            <label class="form-check-label" for="runAiReview">
              ChatGPT-Prüfung vor dem Export
            </label>
          </div>

          <div class="mb-3">
            <label class="form-label" for="chatGptModel">ChatGPT Modell</label>
            <select
              id="chatGptModel"
              class="form-select"
              v-model="chatGptModel"
              :disabled="!runAiReview"
            >
              <option value="">Backend Default</option>
              <option value="gpt-5.1-mini">gpt-5.1-mini (schneller/günstiger)</option>
              <option value="gpt-5.1">gpt-5.1 (bessere Qualität)</option>
            </select>
            <small class="text-muted d-block mt-1">
              Leer = Backend-Default. Wird nur verwendet, wenn die KI-Prüfung aktiv ist.
            </small>
          </div>
          <div class="form-check">
            <input id="autoFixOpenOfficeDocument" class="form-check-input" type="checkbox" v-model="autoFixOpenOfficeDocument" />
            <label class="form-check-label" for="autoFixOpenOfficeDocument">
              Bekannte Platzhalter-/Formatprobleme automatisch korrigieren (Best-Effort)
            </label>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Abbrechen</button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!selectedTemplateId || loadingTemplates"
            @click="submitExport"
          >
            Export starten
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileTemplateService from "@/services/FileTemplateService";

export default {
  name: "OpenOfficeExportModal",
  emits: ["close", "export"],
  data() {
    return {
      templates: [],
      selectedTemplateId: "",
      outputFileName: "",
      loadingTemplates: false,
      runAiReview: true,
      autoFixOpenOfficeDocument: true,
      chatGptModel: "",
    };
  },
  methods: {
    async loadTemplates() {
      this.loadingTemplates = true;
      try {
        const response = await FileTemplateService.getInvoiceTemplates(FileTemplateService.OPENOFFICE_FILE_TYPES);
        this.templates = Array.isArray(response?.data) ? response.data : [];
      } catch (error) {
        console.error("Failed to load OpenOffice templates:", error);
      } finally {
        this.loadingTemplates = false;
      }
    },
    submitExport() {
      this.$emit("export", {
        templateFileId: this.selectedTemplateId,
        outputFileName: this.outputFileName || null,
        runAiReview: this.runAiReview,
        autoFixOpenOfficeDocument: this.autoFixOpenOfficeDocument,
        chatGptModel: this.chatGptModel || null,
      });
    },
    goToTemplateAdmin() {
      this.$emit("close");
      this.$router.push({ name: "TemplateAdmin" });
    },
  },
  mounted() {
    this.loadTemplates();
  },
};
</script>

<style scoped>
.modal.fade.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>

